import { render, staticRenderFns } from "./passDataBox.vue?vue&type=template&id=8eb7bdaa&"
import script from "./passDataBox.vue?vue&type=script&lang=ts&"
export * from "./passDataBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports